import { useTranslation } from "react-i18next";

import cajuAberto from "../../../assets/cajuAberto.png";
import cajuPendurado from "../../../assets/cajuPendurado.jpeg";
import Scroll from "../../Scroll/Scroll";

export default function CajuCultura() {
  const { t } = useTranslation();

  return (
    <>
      <Scroll />
      <section id="cajuCultura-section">
        <h1>{t("castanha.cajucultura.titulo")}</h1>
        <div>
          <p>{t("castanha.cajucultura.descricao.p1")}</p>
          <div>
            <h3>{t("castanha.cajucultura.descricao.p2.titulo")}</h3>
            <p>{t("castanha.cajucultura.descricao.p2.p2-1")}</p>
          </div>
          <div className="cajuCultura-cajueiros">
            <div>
              <h3>
                {t("castanha.cajucultura.descricao.p2.caju.comum.titulo")}
              </h3>
              <p className="descricao">
                {t("castanha.cajucultura.descricao.p2.caju.comum.descricao")}
              </p>
            </div>
            <div>
              <h3>{t("castanha.cajucultura.descricao.p2.caju.anao.titulo")}</h3>
              <p className="descricao">
                {t("castanha.cajucultura.descricao.p2.caju.anao.descricao")}
              </p>
            </div>
          </div>
          <div className="flex">
            <div>
              <br />
              <p
                dangerouslySetInnerHTML={{
                  __html: t("castanha.cajucultura.descricao.p2.p2-2")
                }}
              />
              <br />
              <p className="comentario">
                {t("castanha.cajucultura.descricao.p2.p2-3")}
              </p>
            </div>
            <div>
              <img src={cajuAberto} alt="Imagem de um Caju Aberto no Meio" />
              <p className="legenda">
                {t("castanha.cajucultura.descricao.p2.legenda1")}
              </p>
            </div>
          </div>
          <div className="flex inverter">
            <p>{t("castanha.cajucultura.descricao.p2.p2-4")}</p>
            <div>
              <img src={cajuPendurado} alt="Caju Pendurado na Árvore" />
              <p className="legenda">
                {t("castanha.cajucultura.descricao.p2.legenda2")}
              </p>
            </div>
          </div>
        </div>
      </section>
    </>
  );
}
